import * as API from '../'

export default {
  //获取意向记录列表
  insurePurposeList(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-purpose-record/list', params)
  },
  //获取保险记录列表
  insureRecordList(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-check-record/list/web', params)
  },
  // 记录详情
  recordDetail(params){
    return API.POST(process.env.baseStatistics + '/insure/insure-check-record/detail', params)
  },
  // 产品列表数据
  insureProductList(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-product/list', params)
  },
  // 新增保险产品
  addInsureProduct(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-product/save', params)
  },
  // 发布、下线保险产品
  publicInsureProduct(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-product/update/online', params)
  },
  // 删除保险产品
  delInsureProduct(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-product/delete', params)
  },
  // 保险产品详情
  productDetail(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-product/detail', params)
  },
  // 热门产品设置
  insureHotProduct(params) {
    return API.POST(process.env.baseStatistics + '/insure/insure-product/update/hot', params)
  },
  //获取银行列表
  getBankList() {
    return API.GET(process.env.codeAREA + '/dic/category/list?category=23')
  },
  //获取证件类型字典
  getIdTypeList() {
    return API.GET(process.env.codeAREA+'/dic/category/list?category=20')
  },
}




// WEBPACK FOOTER //
// ./src/api/api_insurance/api_insurance.js